<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>联系我们</span></h1>
  </div>

  <div class="contact-us-content">
    <!-- <div class="tabs">
      <div *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="selectedTab === tab" class="tab">
        {{ tab }}
      </div>
    </div> -->
    <!-- <div *ngIf="selectedTab === 'Phone'" class="content">
      <h2>Call us!</h2>
      <p class="description">
        Do you have questions, requests or suggestions?
        We look forward to your call and will be pleased to assist you.
        You can contact us any time, any day.
      </p>
      <p><strong>Phone 0844 892 0115</strong></p>
      <p style="font-style: italic;">Calls will be charged at local rates. Charges may vary depending on your provider.</p>
    </div> -->
    <div class="mx:grid sm:block grid-cols-3 gap-x-8 gap-y-8">
      <div class="block_wrap bg-[#eff1f2] mx:min-h-[318px] sm:min-h-[284px] mb-4">
        <div class="flex flex-col text-[#006ead]">
          <div class="text-[#006ead] mb-6">
            <svg-icon [iconName]="'official-website/service-agent.svg'"  [isUrl]="false" class="text-[96px]"></svg-icon>
          </div>
          <div>
            <h3 class="mb-[15px] font-bold text-[2rem]">客服</h3>
            <a target="_blank" aria-label="ccc@cn.bosch.com" rel="noopener, noreferrer" href="mailto:ccc@cn.bosch.com" class="text-[#03619A] inline-flex items-center">
              <span>邮箱：ccc@cn.bosch.com</span>
              <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false" class="text-[24px]"></svg-icon></a>
            <a target="_blank" aria-label="4000005109" rel="noopener, noreferrer" href="tel:4000005109" class="text-[#006ead] inline-flex items-center">
              <span>电话：400 000 5109</span>
              <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false"  class="text-[24px]"></svg-icon></a>
          </div>
        </div>
      </div>
      <!-- <div class="block_wrap bg-[#eff1f2] mx:min-h-[318px] sm:min-h-[284px] mb-4">
        <div class="flex flex-col">
          <div class="text-[#006ead] mb-6">
            <svg-icon [iconName]="'official-website/smartphone.svg'"  [isUrl]="false" class="text-[96px]"></svg-icon>
          </div>
          <div>
            <h3 class="mb-[15px] font-bold text-[2rem]">客服电话</h3>
            <a target="_blank" aria-label="4000005109" rel="noopener, noreferrer" href="tel:4000005109" class="text-[#006ead] inline-flex items-center">
              <span class="underline mr-1">400 000 5109</span>
              <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false"  class="text-[24px]"></svg-icon></a>
          </div>
        </div>
      </div> -->
      <div class="block_wrap bg-[#eff1f2] mx:min-h-[318px] sm:min-h-[284px] mb-4">
        <div class="flex flex-col">
          <div class="text-[#006ead] mb-6">
            <svg-icon [iconName]="'official-website/spare-parts.svg'"  [isUrl]="false" class="text-[96px]"></svg-icon>
          </div>
          <div>
            <h3 class="mb-[15px] font-bold text-[2rem]">推荐经销商查询</h3>
            <a target="_blank" aria-label="4000005109" rel="noopener, noreferrer" href="https://wx.bosch-extra.com.cn/map/index.html#/pages/AllRepairAtations/indexDealer?type=ALL&fromApp=boschWebsite" class="text-[#006ead] inline-flex items-center">
              <span class="underline mr-1">跳转链接</span>
              <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false"  class="text-[24px]"></svg-icon></a>
          </div>
        </div>
      </div>
      <div class="block_wrap bg-[#eff1f2] mx:min-h-[318px] sm:min-h-[284px] mb-4">
        <div class="flex flex-col">
          <div class="text-[#006ead] mb-6">
            <svg-icon [iconName]="'official-website/book-service-wrench.svg'"  [isUrl]="false" class="text-[96px]"></svg-icon>
          </div>
          <div>
            <h3 class="mb-[15px] font-bold text-[2rem]">授权维修站查询</h3>
            <a target="_blank" aria-label="4000005109" rel="noopener, noreferrer" href="https://wx.bosch-extra.com.cn/map/index.html#/pages/AllRepairAtations/Workshop?fromApp=boschWebsite" class="text-[#006ead] inline-flex items-center">
              <span class="underline mr-1">跳转链接</span>
              <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false"  class="text-[24px]"></svg-icon></a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>